import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuard} from "../guards/auth.guard";
import {AssetTypesComponent} from "./asset-types.component";
import {AssetSubtypesComponent} from "./asset-subtypes/asset-subtypes.component";
import {AssetTypesImporterComponent} from "./asset-types-importer/asset-types-importer.component";

const routes: Routes = [
  {
    path: 'asset-types',
    component: AssetTypesComponent,
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'asset-types/importer',
    component: AssetTypesImporterComponent,
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'asset-types/:parent_id',
    canActivate: [
      AuthGuard
    ],
    children: [
      {
        path: 'subtypes',
        component: AssetSubtypesComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssetTypesRoutingModule { }
